import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
require("jquery.scrollto");
$(document).ready(() => {
    $('#content').on("click", ".action a", (e) => {
        e.preventDefault();
        $("#form").toggleClass("open");
    });
    $('a[href^="#"').on("click", (e) => {
        e.preventDefault();
        $(".switcher.active").removeClass("active");
        $.scrollTo($($(e.currentTarget).attr("href")).position().top - $("#main-header").outerHeight(), 250);
    });
    $('#form').on("click", "a.close", (e) => {
        e.preventDefault();
        $("#form").toggleClass("open");
    });
    $("#mobile-nav").on("click", ".switcher", (e) => {
        e.preventDefault();
        $(e.currentTarget).toggleClass("active");
    });
});
